import React from 'react';
import ConfirmationDialog from "components/ConfirmationDialog";

const ConfirmDeleteDialog = (props) => {
    const {open, server, onOk, onCancel} = props

    return (
        <ConfirmationDialog
            onCancel={onCancel}
            onConfirm={() => onOk(server)}
            title="Delete SIP Server"
            confirmButtonText="Yes"
            message={`Are you sure you want to delete this SIP Server with ID : ${server.sipServerId}?`}
            visible={open}
        />
   );
};

export default ConfirmDeleteDialog;
